"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "segonzano": {
    "311bcb6a": [{
      "hkey": "d12fd36c",
      "slug": "segonzano",
      "name": "Segonzano",
      "primary": true,
      "skipSearch": false
    }],
    "caloneghi": [{
      "hkey": "d12fd36c",
      "slug": "segonzano",
      "name": "Segonzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3aa20444": [{
      "hkey": "d12fd36c",
      "slug": "segonzano",
      "name": "Segonzano",
      "primary": true,
      "skipSearch": false
    }],
    "casal": [{
      "hkey": "d12fd36c",
      "slug": "segonzano",
      "name": "Segonzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5d0001ac": [{
      "hkey": "d12fd36c",
      "slug": "segonzano",
      "name": "Segonzano",
      "primary": true,
      "skipSearch": false
    }],
    "gausaldo": [{
      "hkey": "d12fd36c",
      "slug": "segonzano",
      "name": "Segonzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e2c866fe": [{
      "hkey": "d12fd36c",
      "slug": "segonzano",
      "name": "Segonzano",
      "primary": true,
      "skipSearch": false
    }],
    "luch": [{
      "hkey": "d12fd36c",
      "slug": "segonzano",
      "name": "Segonzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1aca1328": [{
      "hkey": "d12fd36c",
      "slug": "segonzano",
      "name": "Segonzano",
      "primary": true,
      "skipSearch": false
    }],
    "sabion": [{
      "hkey": "d12fd36c",
      "slug": "segonzano",
      "name": "Segonzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dda3b85a": [{
      "hkey": "d12fd36c",
      "slug": "segonzano",
      "name": "Segonzano",
      "primary": true,
      "skipSearch": false
    }],
    "saletto": [{
      "hkey": "d12fd36c",
      "slug": "segonzano",
      "name": "Segonzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7044a8a3": [{
      "hkey": "d12fd36c",
      "slug": "segonzano",
      "name": "Segonzano",
      "primary": true,
      "skipSearch": false
    }],
    "santuario-della-madonna-dell-aiuto": [{
      "hkey": "d12fd36c",
      "slug": "segonzano",
      "name": "Segonzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0c38ec03": [{
      "hkey": "d12fd36c",
      "slug": "segonzano",
      "name": "Segonzano",
      "primary": true,
      "skipSearch": false
    }],
    "scancio": [{
      "hkey": "d12fd36c",
      "slug": "segonzano",
      "name": "Segonzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3d9a5bea": [{
      "hkey": "eacc0fbf",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "stedro": [{
      "hkey": "eacc0fbf",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "segonzano"
    }]
  }
};
exports["default"] = _default;